import { initVue } from '@core/utils/mainFactory'

void initVue()
